import { Logger } from '@sitecore-search/common';
import EventContext from './eventContext.js';
import { buildEventEntities, track, validateEntities } from './eventUtils.js';
/**
 * @desc Sent when users clicks Recommendation Widget navigation button
 * @param rfkId
 * @param entity
 * @param object: manage recommendation extra event fields
 * @returns  {Promise<void>}
 */
export const trackRecommendationClickEvent = async (rfkId, entity, { actionCause, index, items }) => {
    if (!rfkId) {
        Logger.warn('trackEvent :::', `Widget's rfkId mandatory field is empty`);
        return;
    }
    return await trackClickEvent(rfkId, entity, {
        actionCause,
        index,
        items,
    });
};
/**
 * @desc Sent when users clicks Recommendation Widget entity
 * @param rfkId
 * @param entity
 * @param object: manage recommendation extra event fields
 * @returns  {Promise<void>}
 */
export const trackRecommendationClickEntityEvent = async (rfkId, entity, { index, items }) => {
    if (!rfkId) {
        Logger.warn('trackEvent :::', `Widget's rfkId mandatory field is empty`);
        return;
    }
    return await trackClickEntityEvent(rfkId, entity, {
        actionCause: 'entity',
        index,
        items,
    });
};
/**
 * @desc Sent when user clicks on a widget's entity
 * @param rfkId
 * @param entity
 * @param context
 * @param object: manage extra event fields
 * @returns {Promise<*>}
 */
export const trackClickEntityEvent = async (rfkId, entity, { actionCause, index, items }) => {
    let eventEntities = [];
    if (entity && items) {
        eventEntities = buildEventEntities(entity, items);
        if (eventEntities && !validateEntities(eventEntities)) {
            Logger.warn('trackEvent :::', 'A field is missing on one or more of the items provided');
            return;
        }
    }
    const params = {
        name: 'widget',
        action: 'click',
        action_cause: actionCause,
        value: {
            rfk_id: rfkId,
            index,
            entities: eventEntities,
            context: EventContext.toJson(),
        },
    };
    return track(params);
};
/**
 * @desc Sent when user clicks on any navigation button
 * @param rfkId
 * @param entity
 * @param context
 * @param object: manage extra event fields
 * @returns {Promise<*>}
 */
export const trackClickEvent = async (rfkId, entity, { actionCause, index, items = [] }) => {
    let eventEntities = [];
    if (entity && items) {
        eventEntities = buildEventEntities(entity, items);
        if (eventEntities && !validateEntities(eventEntities)) {
            Logger.warn('trackEvent :::', 'A field is missing on one or more of the items provided');
            return;
        }
    }
    const params = {
        name: 'widget',
        action: 'click',
        ...(actionCause ? { action_cause: actionCause } : {}),
        value: {
            rfk_id: rfkId,
            index,
            entities: eventEntities,
            context: EventContext.toJson(),
        },
    };
    return track(params);
};
